import { NavLink } from 'react-router-dom';
import { HomeIcon, TimelineIcon, ScheduleIcon, RecordsIcon } from '@/components/icons';

const NAV_ITEMS = [
  { to: '/', Icon: HomeIcon, label: 'Home', end: true },
  { to: '/timeline', Icon: TimelineIcon, label: 'Timeline' },
  { to: '/schedule', Icon: ScheduleIcon, label: 'Schedule' },
  { to: '/records', Icon: RecordsIcon, label: 'Records' },
];

export function BottomNav() {
  return (
    <nav className="bottom-nav">
      {NAV_ITEMS.map(({ to, Icon, label, end }) => (
        <NavLink key={to} to={to} end={end} className={({ isActive }) => (isActive ? 'active' : '')}>
          <span className="nav-icon">
            <Icon size={22} />
          </span>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
